import { parseDate } from "../../com/dateUtil";

const url = '/user';

export const getAccountInfo = async (conn, data) => {
  const { userId } = data;

  const config = {
    params: {
      userId: userId,
    },
  };
  const response = await conn.get(url, config);

  return response;
};

export const setUpdateAccountInfo = async (conn, accountInfo) => {
  const data = {
    userId: accountInfo.userId,
    userTerm: accountInfo.userTerm,
    rgnCode: accountInfo.rgnCode,
    dongCode: accountInfo.dongCode,
    userTypeCode: accountInfo.userTypeCode,
    userPassword: accountInfo.userPassword,
    userPhone: accountInfo.userPhone,
    protectorPhone: accountInfo.protectorPhone,
    regiDtm: accountInfo.regiDtm,
    alarmSet: {
      userId: accountInfo.userId,
      kakaoYn: accountInfo.alarmSet.kakaoYn,
      dailyStatusYn: accountInfo.alarmSet.dailyStatusYn,
      dangerYn: accountInfo.alarmSet.dangerYn,
      generalWkdd: accountInfo.alarmSet.generalWkdd,
      generalStartTime: accountInfo.alarmSet.generalStartTime,
      generalEndTime: accountInfo.alarmSet.generalEndTime,
      manageWkdd: accountInfo.alarmSet.manageWkdd,
      manageStartTime: accountInfo.alarmSet.manageStartTime,
      manageEndTime: accountInfo.alarmSet.manageEndTime,
      dangerWkdd: accountInfo.alarmSet.dangerWkdd,
      dangerStartTime: accountInfo.alarmSet.dangerStartTime,
      dangerEndTime: accountInfo.alarmSet.dangerEndTime,
    },
  };

  const response = await conn.post(url, data);

  return response;
};

export const setUpdateAccountInfoMobile = async (conn, accountInfo) => {

  const config = {
    userId: accountInfo.userId,
    userTerm: accountInfo.userTerm,
    dongCode: accountInfo.dongCode,
    userTypeCode: accountInfo.userTypeCode,
    userPassword: accountInfo.userPassword,
    userPhone: accountInfo.userPhone,
    protectorPhone: accountInfo.protectorPhone,
    regiDtm: accountInfo.regiDtm,
    push: accountInfo.push,
  }

  const response = await conn.post(url + "/info", config);

  return response;
};

export const setPersonalInformationConsent = async (conn, data) => {

  const currentDate = new Date();
  const oneYearFromNow = new Date();
  oneYearFromNow.setFullYear(currentDate.getFullYear() + 1);
  
  const config = {
    userId: data.userId,
    personalInformationConsentYn: "Y",
    personalInformationConsentIp: data.personalInformationConsentIp,
    personalInformationConsentGathDtm: parseDate('yyyy-mm-dd hh:mm:ss', currentDate),
    personalInformationConsentEndDtm: parseDate('yyyy-mm-dd hh:mm:ss', oneYearFromNow),

  }
  const response = await conn.post(url + "/pic", config);

  return response;
}